import { AppStateService } from 'core/app-state/app-state.service';
import { AuthenticationService } from '../authentication/authentication.service';
import { AppInfoService } from './app-info.service';
import { currencies, dateFormats, dateLocales, dateTimeFormats, dsDateFormats, weightUnits } from './country-specifics.enum';

export function appInfoResolver(
  appInfoService: AppInfoService,
  appStateService: AppStateService,
  authenticationService: AuthenticationService
) {
  // Check if authenticated user only in online mode
  if (appStateService.state.isOnline && !authenticationService.isAuthenticated) {
    if (!appStateService.state.isInternetConnected) {
      return () => Promise.resolve();
    }
    authenticationService.authorize().then(authorized => {
      if (!authorized) {
        return () => Promise.resolve();
      }
    });
  }

  if (authenticationService.isAuthenticating) {
    return () => Promise.resolve();
  }
  // initialize user data and application strings
  return () => Promise.all([
    appInfoService.initializeAppStrings().toPromise(),
    appInfoService.initializeUserData().toPromise()
  ].map(p => p.catch(() => {
    // This is intentional
  }))).then(([appStrings, userData]) => {
    appInfoService.appStrings = appStrings;
    appInfoService.userData = appInfoService.parseAccessAndModules(userData);
    if (userData && typeof userData !== 'string') {
      appInfoService.dateFormat = dateFormats[appInfoService.userData.UserInfo.CountryCode] || dateFormats.US;
      appInfoService.dateTimeFormat = dateTimeFormats[appInfoService.userData.UserInfo.CountryCode] || dateTimeFormats.US;
      appInfoService.dsDateFormat = dsDateFormats[appInfoService.userData.UserInfo.CountryCode] || dsDateFormats.US;
      appInfoService.currencySymbol = currencies[appInfoService.userData.UserInfo.CountryCode] || currencies.US;
      appInfoService.weightSymbol = weightUnits[appInfoService.userData.UserInfo.CountryCode] || weightUnits.US;
      appInfoService.dateLocale = dateLocales[appInfoService.userData.UserInfo.CountryCode] || dateLocales.US;
    }
  }).then(() => {
    if (appStateService.state.isElectron && appStateService.state.isOnline && appInfoService.userData) {
      // if set offline user info fails, remove access by setting user data to null.
      return appInfoService.setOfflineUserInfo().toPromise().catch(() => appInfoService.userData = null);
    }
  });
}
